export default {"src":"/_next/static/media/figo_icon_light_va_projektdaten.a560dc29.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};